/**
 * MenuDetailPresenter
 * --
 */
import React from 'react';
import { Content, Row, Col, Title } from 'components';
import { Empty } from 'antd';

const MenuDetailPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <Empty
              style={{
                height: 500,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
              description={
                <>
                  <Title align={'center'}>개발중입니다.</Title>
                </>
              }
            ></Empty>
          </Content>
        </Col>
      </Row>
    </Content>
  );
};

export default MenuDetailPresenter;
